import { fetchMemberByOrganization } from 'api/portal';
import { useEffect } from 'react';

export function useFetchMemberForAdmin({ orgId, memberId, onSuccess = () => {}, onFailure = () => {} }) {
  useEffect(() => {
    fetchMemberByOrganization(orgId, memberId)
      .then((response) => {
        const { data } = response;
        onSuccess(data);
      })
      .catch(() => {
        onFailure();
      });
  }, []);
}
